import { render } from "./ModernLoader.vue?vue&type=template&id=dca2820a&scoped=true"
const script = {}

import "./ModernLoader.vue?vue&type=style&index=0&id=dca2820a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca2820a"]])

export default __exports__